import ClientLogger from './clientLogger';
import { Logger } from './logger';

class LoggerFactory {
  private static loggers: Map<string, Logger> = new Map();

  static async getLogger(serviceName: string): Promise<Logger> {
    if (this.loggers.has(serviceName)) {
      return this.loggers.get(serviceName)!;
    }

    const isServer = typeof window === 'undefined';
    let logger: Logger;

    if (isServer) {
      try {
        // Dynamically import to prevent webpack from bundling server code for client
        const { default: ServerLoggerClass } = await import('./serverLogger');
        logger = new ServerLoggerClass(serviceName);
      } catch (e) {
        console.warn('Failed to initialize server logger', e);
        logger = new ClientLogger(serviceName);
      }
    } else {
      logger = new ClientLogger(serviceName);
    }

    this.loggers.set(serviceName, logger);
    return logger;
  }
}

export default LoggerFactory;
